import { render, staticRenderFns } from "./MultiFixedLimits.vue?vue&type=template&id=1a82d86b&scoped=true&"
import script from "./MultiFixedLimits.vue?vue&type=script&lang=js&"
export * from "./MultiFixedLimits.vue?vue&type=script&lang=js&"
import style0 from "./MultiFixedLimits.vue?vue&type=style&index=0&id=1a82d86b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a82d86b",
  null
  
)

export default component.exports